import { CarouselTypes, type FeaturedCarousel } from '@setplex/tria-api'
import { type FeaturedChannelsCarousel } from './index.h'

export const isChannelsCarousel = (
  carousel: FeaturedCarousel
): carousel is FeaturedChannelsCarousel =>
  carousel.type === CarouselTypes.TV_CHANNEL
